import React, { useEffect, useState } from "react";
import styles from "./MemberProfile.module.css";
import { useParams } from "react-router-dom";
import FullProfile from "../../components/ProfileCard/FullProfile/FullProfile";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";
import { API_ENDPOINTS } from "../../api/endpoints";
import apiClient from "../../api/apiClient";
import { useNavigate } from "react-router-dom";

export default function MemberProfile() {
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [userData, setUserData] = useState([]);
  const [similarProfiles, setSimilarProfiles] = useState([]);

  const { id } = useParams();
  const { pathname } = useLocation();
  const role = pathname.includes("mentors") ? "mentor" : "author";
  const navigate = useNavigate();

  useEffect(() => {
    fetchProfileData();
  }, []);
  const fetchProfileData = async () => {
    try {
      setLoading(true);
      const res = await apiClient({
        url: `${
          role === "mentor"
            ? API_ENDPOINTS.VIEW_MENTOR_PROFILE
            : role === "author"
            ? API_ENDPOINTS.VIEW_AUTHOR_PROFILE
            : null
        }/${id}`,
        method: "get",
        withAuth: true,
      });

      const profile = res?.data?.data;
      setUserData(profile);
    fetchSimilarProfiles(profile.department);
    } catch (error) {
      console.error("Profile GET Error:", error);
      setApiError(error);
    }

    setLoading(false);
  };
  const fetchSimilarProfiles = async (dep) => {
    try {
      setLoading(true);
      const res = await apiClient({
        url: `${
          role === "mentor"
            ? `${API_ENDPOINTS.MENTOR_SIMILAR_PROFILE}/${id}?similarMentors`
            : role === "author"
            ? `${API_ENDPOINTS.AUTHOR_SIMILAR_PROFILE}/${id}?similarAuthors`
            : null
        }=${dep}`,
        method: "get",
        withAuth: true,
      });

      const finalData = role === "mentor" ? res?.data?.mentors :  role === "author" ? res?.data?.authors : null;
      setSimilarProfiles(finalData);
    } catch (error) {
      console.error("Profile GET Error:", error);
      setApiError(error);
    }

    setLoading(false);
  };

  return (
    <main className={styles.profile}>
      <div className={`${styles.container} `}>
        <div className={styles.backBtnContainer}>
          <button className={styles.backLink} onClick={() => navigate(-1)}>
            &lt; Back
          </button>
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : apiError ? (
        <ErrorMsg />
      ) : (
        <FullProfile
          profile={userData}
          rating={5}
          badge={"Highly Rated Expert"}
          similarProfiles={similarProfiles}
        />
      )}
    </main>
  );
}
